import { useAudienceSearchContext } from "../../AudienceSearchContext";
import type { GeoLocationFilterProps } from "../../SharedFilters/GeoLocationFilter";
import { GeoLocationFilter } from "../../SharedFilters/GeoLocationFilter";
import { useCrmTrueLocationFieldAndSearchEnabled } from "../../useCrmLocationEnabled";
import type { TextFieldFilterProps } from "./TextFieldFilter";
import { TextFieldFilter } from "./TextFieldFilter";

type LocationFilterProps = TextFieldFilterProps | GeoLocationFilterProps;

export const LocationFieldFilter = (props: LocationFilterProps) => {
  const isEnabled = useCrmTrueLocationFieldAndSearchEnabled();
  const { isContactsSearch } = useAudienceSearchContext();

  if (isEnabled && isContactsSearch) {
    return <GeoLocationFilter {...(props as GeoLocationFilterProps)} />;
  }

  return <TextFieldFilter {...(props as TextFieldFilterProps)} />;
};
